
export { AuthenticatedAPI } from "/__w/wiggot-web/wiggot-web/packages/core-apis/src/apis/config/api/authenticatedApi.ts"
export { HttpRequestService } from "/__w/wiggot-web/wiggot-web/packages/core-apis/src/apis/config/httpService.ts"